module.exports = __webpack_public_path__ + "img/instagram.da5274b5.svg";